/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable  @typescript-eslint/no-explicit-any */

import { createAsyncAction } from 'Helpers/redux'

import { apiCall } from './api'

export const GET_TOTAL_PAYMENT_PERIOD = createAsyncAction(
  'GET_TOTAL_PAYMENT_PERIOD'
)

export const getTotalPaymentPeriod = (ranges: any) =>
  apiCall({
    method: 'get',
    endpoint: `/analytics/total-payment-period/${ranges}`,
    types: GET_TOTAL_PAYMENT_PERIOD,
  })

export const GET_FIRST_PAYMENT_PERIOD = createAsyncAction(
  'GET_FIRST_PAYMENT_PERIOD'
)
export const getFirstPaymentPeriod = (ranges: any) =>
  apiCall({
    method: 'get',
    endpoint: `/analytics/first-payment-period/${ranges}`,
    types: GET_FIRST_PAYMENT_PERIOD,
  })

export const GET_REPEATED_PAYMENT_PERIOD = createAsyncAction(
  'GET_REPEATED_PAYMENT_PERIOD'
)
export const getRepeatedPaymentPeriod = (ranges: any) =>
  apiCall({
    method: 'get',
    endpoint: `/analytics/repeated-payment-period/${ranges}`,
    types: GET_REPEATED_PAYMENT_PERIOD,
  })

export const GET_REQUEST_ACTIVITY = createAsyncAction('GET_REQUEST_ACTIVITY')
export const getRequestsActivity = (ranges: any) =>
  apiCall({
    method: 'get',
    endpoint: `/analytics/requests-activity/${ranges}`,
    types: GET_REQUEST_ACTIVITY,
  })
